// this should be in Common Angular Library! as we don't have use case to create one now
// hence this is stick here as security is widely use
var Error = /** @class */ (function () {
    function Error() {
    }
    return Error;
}());
export { Error };
var ErrorDetails = /** @class */ (function () {
    function ErrorDetails() {
    }
    return ErrorDetails;
}());
export { ErrorDetails };
var IPagedList = /** @class */ (function () {
    function IPagedList() {
    }
    return IPagedList;
}());
export { IPagedList };
//
